"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @file Created on Thu May 09 2019
 */

var big_decimal_1 = require("@logio/big-decimal");

var immutable_1 = require("immutable");

var CodebookLookupSequence_1 = require("../../core/model/codebook/CodebookLookupSequence");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var PriceFormulas_1 = require("../../core/model/math/PriceFormulas");

var utils_1 = require("../../core/utils");

var SupplierAgreement_1 = require("../../supply/model/SupplierAgreement");

var SimulationValidator_1 = require("../validation/SimulationValidator");

var SimulationBigNumber_1 = require("./SimulationBigNumber");

var SimulationObject_1 = require("./SimulationObject");

var SimulationState_1 = require("./SimulationState");

var SimulationString_1 = require("./SimulationString");

var WindowItemPosAttributes_1 = require("./WindowItemPosAttributes");
/**
 * @author BPo
 * @author Tomas Leity
 */


var WindowItemSimulation =
/*#__PURE__*/
function (_SimulationObject_1$S) {
  _inherits(WindowItemSimulation, _SimulationObject_1$S);

  /**
   * @param id unique ID of this entity
   * @param simulationId ID of the {@link PromotionSimulation} entity
   * @param originId Id of {@link WindowItem} element from which entity is based on. If an element
   * is created from a DummyWindow, the originId will be null.
   * @param state An overall status of entity simulation values and their approval
   * @param regularPrice It is currently valid last open regular price. This value is for
   * PM only Changes are not reflected on Window/Product level. It`s
   * for reporting purposes.
   * @param promoPrice Simulated user input price, default value is regular price
   * @param promoVolume Value from user, default value is systemVolume.
   * @param posMarginImpactTheoretical This is a numeric field and values can be positive or negative,
   * mostly will be negative values as it represents the amount of czk
   * that should be deducted form the window sales and margin to
   * represent the discount effect from the PoS mechanic.
   * @param posMarginImpactExpected Computed value based on posMarginImpactTheoretical,
   * @param posRedemption mandatory number field with percentage value. Default value is 100%.
   * Based on this number the field POS Margin impact expected is calculated
   * @param posMechanics POS text description.
   * @param vaValue This value is only for PM, the change is not reflected on Window.
   * It is only for reporting. Only user KPI VA in value can be simulated.
   * @param promoPurchasePrice Promotion purchase price in supplier´s currency. This field is taken
   * from the {@link SupplierAgreement} entity
   * @param unitBackDiscount Back discount on product in supplier currency. This field is taken
   * from the {@link SupplierAgreement} entity
   * @param preferredPromoPurchasePrice promo purchase price of preferred {@link Supplier}
   * @param preferredPromoPurchaseStartDate promo purchase price start date of preferred {@link Supplier}
   * @param preferredUnitBackDiscount unit back discount of preferred {@link Supplier}
   * @param preferredSupplierId ID of preferred supplier
   * @param preferredCurrencyId ID of preferred supplier's currency - currency of "preferred" price fields in this object
   * @param preferredRegularPurchasePrice
   * @param preferredRegularPurchasePriceNett
   */
  function WindowItemSimulation(id, simulationId, originId, state, regularPrice, promoPrice, promoVolume, posMarginImpactTheoretical, posMarginImpactExpected, posRedemption, posMechanics, vaValue, promoPurchasePrice, unitBackDiscount, preferredPromoPurchasePrice, preferredPromoPurchaseStartDate, preferredUnitBackDiscount, preferredSupplierId, preferredCurrencyId, preferredRegularPurchasePrice, preferredRegularPurchasePriceNett) {
    var _this;

    _classCallCheck(this, WindowItemSimulation);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowItemSimulation).call(this, state));
    _this.id = id;
    _this.simulationId = simulationId;
    _this.originId = originId;
    _this.state = state;
    _this.regularPrice = regularPrice;
    _this.promoPrice = promoPrice;
    _this.promoVolume = promoVolume;
    _this.posMarginImpactTheoretical = posMarginImpactTheoretical;
    _this.posMarginImpactExpected = posMarginImpactExpected;
    _this.posRedemption = posRedemption;
    _this.posMechanics = posMechanics;
    _this.vaValue = vaValue;
    _this.promoPurchasePrice = promoPurchasePrice;
    _this.unitBackDiscount = unitBackDiscount;
    _this.preferredPromoPurchasePrice = preferredPromoPurchasePrice;
    _this.preferredPromoPurchaseStartDate = preferredPromoPurchaseStartDate;
    _this.preferredUnitBackDiscount = preferredUnitBackDiscount;
    _this.preferredSupplierId = preferredSupplierId;
    _this.preferredCurrencyId = preferredCurrencyId;
    _this.preferredRegularPurchasePrice = preferredRegularPurchasePrice;
    _this.preferredRegularPurchasePriceNett = preferredRegularPurchasePriceNett;
    return _this;
  }
  /**
   * Applies simulation attributes into preferred attributes.
   */


  _createClass(WindowItemSimulation, [{
    key: "applySimulation",
    value: function applySimulation() {
      var pp = this.promoPurchasePrice ? this.promoPurchasePrice.simulatedValue : this.preferredPromoPurchasePrice;
      var ubd = this.unitBackDiscount ? this.unitBackDiscount.simulatedValue : this.preferredUnitBackDiscount;
      return this.copy('preferredPromoPurchasePrice', pp).copy('preferredUnitBackDiscount', ubd);
    }
    /**
     * Returns true if there is at least one filled simulation value that is not rejected and not all
     * acceptable values were rejected.
     */

  }, {
    key: "hasNonRejectedSimulationValue",
    value: function hasNonRejectedSimulationValue() {
      var hasNonRejectedValue = this.getAcceptableValues().valueSeq().some(function (simValue) {
        return simValue !== null && !simValue.isRejected();
      });
      var allAcceptableValuesRejected = this.getAcceptableValues().valueSeq().every(function (simValue) {
        return simValue === null || simValue.isRejected();
      });
      return hasNonRejectedValue && !allAcceptableValuesRejected;
    }
    /**
     * Returns true if atleast one simulation value is rejected
     */

  }, {
    key: "hasRejectedSimulation",
    value: function hasRejectedSimulation() {
      return this.getValues().valueSeq().some(function (simValue) {
        return simValue !== null && simValue.isRejected();
      });
    }
    /**
     * Returns true only if some simulation value is waiting to be accepted
     */

  }, {
    key: "hasWaitingToAcceptSimulation",
    value: function hasWaitingToAcceptSimulation() {
      return this.getValues().valueSeq().some(function (simValue) {
        return simValue !== null && simValue.simulatedValue !== null && simValue.accepted === null;
      });
    }
  }, {
    key: "synthesizeAgreement",
    value: function synthesizeAgreement(windowItemId, isDummy) {
      return SupplierAgreement_1.SupplierAgreement.empty().copyMulti({
        windowItemId: windowItemId,
        supplierId: this.preferredSupplierId,
        currencyId: this.preferredCurrencyId,
        unitBackDiscount: this.preferredUnitBackDiscount,
        regularPurchasePrice: this.preferredRegularPurchasePrice,
        regularPurchasePriceNett: this.preferredRegularPurchasePriceNett,
        promoPurchasePrice: this.preferredPromoPurchasePrice,
        promoPurchaseStartDate: this.preferredPromoPurchaseStartDate,
        promoPurchasePricePlus: PriceFormulas_1.PriceFormulas.computePromoPurchasePricePlus(this.preferredRegularPurchasePrice, this.preferredRegularPurchasePriceNett, this.preferredPromoPurchasePrice),
        split: big_decimal_1.bigdecimal(1),
        preferred: true
      });
    }
  }, {
    key: "getValues",

    /**
     * @inheritDoc
     */
    value: function getValues() {
      return immutable_1.Map([[WindowItemSimulation.schema.regularPrice.simpleNameKey(), this.regularPrice], [WindowItemSimulation.schema.promoPrice.simpleNameKey(), this.promoPrice], [WindowItemSimulation.schema.promoVolume.simpleNameKey(), this.promoVolume], [WindowItemSimulation.schema.promoPurchasePrice.simpleNameKey(), this.promoPurchasePrice], [WindowItemSimulation.schema.posMarginImpactTheoretical.simpleNameKey(), this.posMarginImpactTheoretical], [WindowItemSimulation.schema.posMechanics.simpleNameKey(), this.posMechanics], [WindowItemSimulation.schema.vaValue.simpleNameKey(), this.vaValue], [WindowItemSimulation.schema.unitBackDiscount.simpleNameKey(), this.unitBackDiscount]]);
    }
    /**
     * Gets acceptable values that can be simulated
     *
     * @returns {Map<string, SimulationValue<any>} simulated values
     */

  }, {
    key: "getAcceptableValues",
    value: function getAcceptableValues() {
      return immutable_1.Map([[WindowItemSimulation.schema.promoPrice.simpleNameKey(), this.promoPrice], [WindowItemSimulation.schema.promoVolume.simpleNameKey(), this.promoVolume], [WindowItemSimulation.schema.promoPurchasePrice.simpleNameKey(), this.promoPurchasePrice], [WindowItemSimulation.schema.posMarginImpactTheoretical.simpleNameKey(), this.posMarginImpactTheoretical], [WindowItemSimulation.schema.posMechanics.simpleNameKey(), this.posMechanics], [WindowItemSimulation.schema.unitBackDiscount.simpleNameKey(), this.unitBackDiscount]]);
    }
    /**
     * Decides a simulation state based on simulated values.
     */

  }, {
    key: "computeSimulationState",
    value: function computeSimulationState() {
      var simulationValues = this.getAcceptableValues().valueSeq();

      if (simulationValues.some(function (value) {
        return value !== null && value.accepted === null;
      })) {
        return SimulationState_1.SimulationState.Pending;
      }

      if (simulationValues.some(function (value) {
        return value !== null && value.accepted === false;
      })) {
        return SimulationState_1.SimulationState.Rejected;
      }

      return SimulationState_1.SimulationState.Empty;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "validator",
    value: function validator(type) {
      if (type === SimulationValidator_1.SimulationValidatorType.ACCEPTABLE) {
        return new SimulationValidator_1.SimulationValidator(SimulationValidator_1.SimulationValidatorType.ACCEPTABLE, this, this.getAcceptableValues());
      }

      return new SimulationValidator_1.SimulationValidator(SimulationValidator_1.SimulationValidatorType.FULL, this, this.getValues());
    }
    /**
     * LOG-7132
     * Calculates posMarginImpactExpected within {@link WindowItemSimulation}.
     *
     * @param impactTheoretical
     */

  }, {
    key: "calcMarginExpected",
    value: function calcMarginExpected() {
      var impactTheoretical = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : big_decimal_1.bigdecimal(0);
      var simImpactTheoretical = this.posMarginImpactTheoretical ? this.posMarginImpactTheoretical.simulatedValue : impactTheoretical;
      return this.copy('posMarginImpactExpected', WindowItemPosAttributes_1.WindowItemPosAttributes.calcMarginExpected(simImpactTheoretical, this.posRedemption));
    }
  }], [{
    key: "fromAgreement",
    value: function fromAgreement(id, simulationId, item, sa) {
      return new WindowItemSimulation(id, simulationId, item.id, SimulationState_1.SimulationState.Empty, null, null, null, null, item.posAttributes.posMarginImpactExpected, item.posAttributes.posRedemption, null, null, null, null, utils_1.Utils.assertDefined(sa.promoPurchasePrice), sa.promoPurchaseStartDate, sa.unitBackDiscount || big_decimal_1.bigdecimal(0), sa.supplierId, sa.currencyId, utils_1.Utils.assertDefined(sa.regularPurchasePrice), utils_1.Utils.assertDefined(sa.regularPurchasePriceNett));
    }
    /**
     * Converter from data-dictionary representation
     */

  }, {
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new WindowItemSimulation(mat.id, mat.simulationId, mat.originId, mat.state, mat.regularPrice, mat.promoPrice, mat.promoVolume, mat.posMarginImpactTheoretical, mat.posMarginImpactExpected, mat.posRedemption, mat.posMechanics, mat.vaValue, mat.promoPurchasePrice, mat.unitBackDiscount, mat.preferredPromoPurchasePrice, mat.preferredPromoPurchaseStartDate, mat.preferredUnitBackDiscount, mat.preferredSupplierId, mat.preferredCurrencyId, mat.preferredRegularPurchasePrice, mat.preferredRegularPurchasePriceNett);
    }
  }]);

  return WindowItemSimulation;
}(SimulationObject_1.SimulationObject);

exports.WindowItemSimulation = WindowItemSimulation;
WindowItemSimulation.DOCUMENT_TYPE = 'WindowItemSimulation';

WindowItemSimulation.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(WindowItemSimulation.name);
  return {
    id: builder.id('id'),
    simulationId: builder.id('simulationId'),
    originId: builder.opt(builder.id('originId')),
    state: builder.senum('state', SimulationState_1.SimulationState, CodebookLookupSequence_1.CodebookLookupSequence.SimulationState),
    regularPrice: builder.opt(builder.obj('regularPrice', SimulationBigNumber_1.SimulationBigNumber.schema, function (mat) {
      return SimulationBigNumber_1.SimulationBigNumber.fromDataDict(mat);
    })),
    promoPrice: builder.opt(builder.obj('promoPrice', SimulationBigNumber_1.SimulationBigNumber.schema, function (mat) {
      return SimulationBigNumber_1.SimulationBigNumber.fromDataDict(mat);
    })),
    promoVolume: builder.opt(builder.obj('promoVolume', SimulationBigNumber_1.SimulationBigNumber.schema, function (mat) {
      return SimulationBigNumber_1.SimulationBigNumber.fromDataDict(mat);
    })),
    posMarginImpactTheoretical: builder.opt(builder.obj('posMarginImpactTheoretical', SimulationBigNumber_1.SimulationBigNumber.schema, function (mat) {
      return SimulationBigNumber_1.SimulationBigNumber.fromDataDict(mat);
    })),
    posMarginImpactExpected: builder.bigNum('posMarginImpactExpected'),
    posRedemption: builder.bigNum('posRedemption'),
    posMechanics: builder.opt(builder.obj('posMechanics', SimulationString_1.SimulationString.schema, function (mat) {
      return SimulationString_1.SimulationString.fromDataDict(mat);
    })),
    vaValue: builder.opt(builder.obj('vaValue', SimulationBigNumber_1.SimulationBigNumber.schema, function (mat) {
      return SimulationBigNumber_1.SimulationBigNumber.fromDataDict(mat);
    })),
    promoPurchasePrice: builder.opt(builder.obj('promoPurchasePrice', SimulationBigNumber_1.SimulationBigNumber.schema, function (mat) {
      return SimulationBigNumber_1.SimulationBigNumber.fromDataDict(mat);
    })),
    unitBackDiscount: builder.opt(builder.obj('unitBackDiscount', SimulationBigNumber_1.SimulationBigNumber.schema, function (mat) {
      return SimulationBigNumber_1.SimulationBigNumber.fromDataDict(mat);
    })),
    preferredPromoPurchasePrice: builder.bigNum('preferredPromoPurchasePrice'),
    preferredPromoPurchaseStartDate: builder.opt(builder.date('preferredPromoPurchaseStartDate')),
    preferredUnitBackDiscount: builder.bigNum('preferredUnitBackDiscount'),
    preferredSupplierId: builder.str('preferredSupplierId'),
    preferredCurrencyId: builder.str('preferredCurrencyId'),
    preferredRegularPurchasePrice: builder.bigNum('preferredRegularPurchasePrice'),
    preferredRegularPurchasePriceNett: builder.bigNum('preferredRegularPurchasePriceNett')
  };
}();